import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlFullscreen extends BaseControl {
    constructor(pano: Pano) {
        super(pano, ControlPosition.RIGHT);

        this.element.classList.add("control-button", "fullscreen");
        this.element.setAttribute("state", "normal");
        this.element.innerHTML = `
        <div class="control-button-icon icon-249 fullscreen"></div>
        <div class="control-button-icon icon-250 normal"></div>
        `;

        e5.FullscreenUtil.onChange.add((fullscreen) => {
            this.element.setAttribute("state", fullscreen ? "fullscreen" : "normal");
        });
        this.element.addEventListener("click", (e) => {
            e5.FullscreenUtil.toggle(this.pano.element);
        });
    }
}